import * as Yup from "yup";
import {
  mkaRules,
  commonFieldsRules,
  commonFieldsRulesClose,
} from "../validation/validator";

const addRules = {
  ...commonFieldsRules,
  ...mkaRules,
  standartTime: Yup.number()
    .typeError("Введите нормативное время")
    .min(1, "Минимальное значение 1 "),
  dateTimePlanned: Yup.string().nullable(true).required("Выберите дату"),
  gasPlannedTime: Yup.string()
    .nullable(true)
    .test(function (val) {
      if (typeof val === "string") {
        return (
          val.length === 5 ||
          !val.length ||
          this.createError({ message: "Проверьте корректность данных" })
        );
      }
      return true;
    })
    .required("Выберите время"),
  overBuildings: Yup.number()
    .transform((value, original) =>
      original == null || original === "" ? undefined : value,
    )
    .positive()
    .when(
      [
        "livingBuildings",
        "hospitalBuildings",
        "childrenBuildings",
        "buildings",
      ],
      (
        livingBuildings,
        hospitalBuildings,
        childrenBuildings,
        buildings,
        schema,
      ) => {
        return livingBuildings > 0 ||
          hospitalBuildings > 0 ||
          childrenBuildings > 0 ||
          buildings > 0
          ? schema.min(
              Math.max(
                livingBuildings,
                hospitalBuildings,
                childrenBuildings,
                buildings,
              ),
              `Минимальное значение ${Math.max(
                livingBuildings > 0 && livingBuildings,
                hospitalBuildings > 0 && hospitalBuildings,
                childrenBuildings > 0 && childrenBuildings,
                buildings > 0 && buildings,
              )}`,
            )
          : schema.min(null);
      },
    ),
};

const editRules = {
  ...addRules,
  //classifierTypeId: Yup.string().typeError("Выберите тип классификатора"),
  //objectTypeId: Yup.string().typeError("Выберите тип объекта"),
  //objectId: Yup.string().typeError("Выберите краткое наименование объекта"),
  overBuildings: Yup.number()
    .positive()
    .when(
      [
        "livingBuildings",
        "hospitalBuildings",
        "childrenBuildings",
        "buildings",
      ],
      (
        livingBuildings,
        hospitalBuildings,
        childrenBuildings,
        buildings,
        schema,
      ) => {
        return livingBuildings > 0 ||
          hospitalBuildings > 0 ||
          childrenBuildings > 0 ||
          buildings > 0
          ? schema.min(
              Math.max(
                livingBuildings,
                hospitalBuildings,
                childrenBuildings,
                buildings,
              ),
              `Минимальное значение ${Math.max(
                livingBuildings > 0 && livingBuildings,
                hospitalBuildings > 0 && hospitalBuildings,
                childrenBuildings > 0 && childrenBuildings,
                buildings > 0 && buildings,
              )}`,
            )
          : schema.min(null);
      },
    )
    .typeError("Введите кол-во"),
  livingBuildings: Yup.number().typeError("Введите кол-во"),
  hospitalBuildings: Yup.number().typeError("Введите кол-во"),
  childrenBuildings: Yup.number().typeError("Введите кол-во"),
  buildings: Yup.number().typeError("Введите кол-во"),
  diameter: Yup.number().typeError("Введите диаметр трубы"),
  pressureValue: Yup.number().typeError("Введите давление"),
};

export const addSchemaGasCommunication = Yup.object().shape(addRules);
export const editSchemaGasCommunication = Yup.object().shape(editRules);
export const closeSchemaGasCommunication = Yup.object().shape({
  ...editRules,
  ...commonFieldsRulesClose,
});
